import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Film,
  Clock,
  Calendar,
  FileText,
  Image,
  MessageSquare,
  Briefcase,
  Settings,
  Users,
  Clapperboard,
} from 'lucide-react';
import { useIsOwner, useIsAdmin } from '@/store/auth';
import { clsx } from 'clsx';

const navigation = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard },
  { name: 'Movies', href: '/movies', icon: Film },
  { name: 'Showtimes', href: '/showtimes', icon: Clock },
  { name: 'Events', href: '/events', icon: Calendar },
  { name: 'Pages', href: '/pages', icon: FileText },
  { name: 'Media', href: '/media', icon: Image },
];

const adminNavigation = [
  { name: 'Inquiries', href: '/inquiries', icon: MessageSquare },
  { name: 'Jobs', href: '/jobs', icon: Briefcase },
  { name: 'Settings', href: '/settings', icon: Settings },
];

const ownerNavigation = [{ name: 'Users', href: '/users', icon: Users }];

export function Sidebar() {
  const isOwner = useIsOwner();
  const isAdmin = useIsAdmin();

  return (
    <aside className="flex w-64 flex-col border-r border-midnight-100 bg-midnight-50">
      {/* Logo */}
      <div className="flex h-16 items-center gap-2 border-b border-midnight-100 px-6">
        <Clapperboard className="h-8 w-8 text-gold" />
        <div>
          <h1 className="text-lg font-bold text-white">DMAX</h1>
          <p className="text-xs text-gray-500">Admin Panel</p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 overflow-auto px-3 py-4">
        <div className="mb-4">
          <p className="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-gray-500">
            Content
          </p>
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              end={item.href === '/'}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-gold/10 text-gold'
                    : 'text-gray-400 hover:bg-midnight-100 hover:text-white'
                )
              }
            >
              <item.icon className="h-5 w-5" />
              {item.name}
            </NavLink>
          ))}
        </div>

        {isAdmin && (
          <div className="mb-4">
            <p className="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-gray-500">
              Management
            </p>
            {adminNavigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) =>
                  clsx(
                    'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-gold/10 text-gold'
                      : 'text-gray-400 hover:bg-midnight-100 hover:text-white'
                  )
                }
              >
                <item.icon className="h-5 w-5" />
                {item.name}
              </NavLink>
            ))}
          </div>
        )}

        {isOwner && (
          <div>
            <p className="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-gray-500">
              Administration
            </p>
            {ownerNavigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) =>
                  clsx(
                    'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-gold/10 text-gold'
                      : 'text-gray-400 hover:bg-midnight-100 hover:text-white'
                  )
                }
              >
                <item.icon className="h-5 w-5" />
                {item.name}
              </NavLink>
            ))}
          </div>
        )}
      </nav>

      {/* Footer */}
      <div className="border-t border-midnight-100 p-4">
        <p className="text-xs text-gray-500 text-center">DMAX Cinema Admin v0.1.0</p>
      </div>
    </aside>
  );
}
